import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { injectIntl, intlShape } from 'react-intl';

import css from './index.scss';

import messages from './messages';

import { CURRICULUM_TABS } from '../../constants';

import Header from '../../components/header/index';
import CurriculumList from '../curriculum-list/index';
import MasterCourses from '../master-courses/index';
import CurriculumDocuments from '../curriculum-documents/index';
import TabButton from '../../components/tab-button/index';

class CurriculumManagerContainer extends PureComponent {
    static propTypes = {
        intl: intlShape.isRequired
    }

    render() {
        const { intl } = this.props;
        CURRICULUM_TABS[0].name = intl.formatMessage(messages.curriculums);
        CURRICULUM_TABS[1].name = intl.formatMessage(messages.masterCourses);
        CURRICULUM_TABS[2].name = intl.formatMessage(messages.curriculumDocuments);

        return (
            <div className={css.curriculumManagerComponent} >
                <Header
                    headerTitle={this.props.intl.formatMessage(messages.curriculumManager)}
                    tabs={CURRICULUM_TABS}
                />
                <div className={css.tabHolder}>
                    <div className={css.tabContainer}>
                        {
                            CURRICULUM_TABS.map((val, index) =>
                                <TabButton key={val.id} name={val.name} route={val.route} tabIndex={index} />
                            )
                        }
                    </div>
                </div>
                <div className={css.mainContent} >
                    <Route component={CurriculumList} path="/curriculum-list" />
                    <Route component={MasterCourses} path="/master-courses" />
                    <Route component={CurriculumDocuments} path="/curriculum-documents" />
                </div>
            </div>
        );
    }
}

function mapStateToProps() {
    return {};
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
    }, dispatch);
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(CurriculumManagerContainer));



// WEBPACK FOOTER //
// ./app/containers/curriculum-manager/index.js